'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import debounce from 'react-utils/debounce';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { device } from '../constants/StyledComponentConstants';
import useMediaQuery from '../hooks/useMediaQuery';
import Scrollbar from './Scrollbar';
const CarouselOuter = styled.div.withConfig({
  displayName: "Carousel__CarouselOuter",
  componentId: "sc-1seeoyu-0"
})(["width:calc( 100% + max( ", "px,", " ) * 2 );margin-left:calc( max( ", "px,", " ) * -1 );padding-left:calc( max( ", "px,", " ) );padding-right:calc( max( ", "px,", " ) );overflow-x:auto;scrollbar-color:transparent transparent;scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{background:transparent;display:none;}&::-webkit-scrollbar-thumb{background:transparent !important;}"], props => props.pageMargin, props => props.fixedMargin ? '0px' : '(100vw - 1296px)', props => props.pageMargin, props => props.fixedMargin ? '0px' : '(100vw - 1296px) / 2', props => props.pageMargin, props => props.fixedMargin ? '0px' : '(100vw - 1296px) / 2', props => props.pageMargin, props => props.fixedMargin ? '0px' : '(100vw - 1296px) * 1.5');
const CarouselFlex = styled(UIFlex).withConfig({
  displayName: "Carousel__CarouselFlex",
  componentId: "sc-1seeoyu-1"
})(["width:max-content;max-width:unset;padding-bottom:16px;padding-top:1px;padding-left:1px;.carousel-child:not(:last-child){margin-right:16px;}"]);

const Carousel = ({
  children,
  onClosestChildChange,
  pageMargin,
  fixedMargin,
  carouselClassName
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [carouselContainerRef, setCarouselContainerRef] = useState();
  const [childrenRefs, setChildrenRefs] = useState([]);
  const handleCarouselScroll = useCallback(() => debounce(() => {
    let previousClosest = 0;

    for (let i = 0; i < childrenRefs.length; i++) {
      const el = childrenRefs[i];
      const previousClosestEl = childrenRefs[previousClosest];

      if (Math.abs(carouselContainerRef.getBoundingClientRect().x - el.getBoundingClientRect().x) <= Math.abs(carouselContainerRef.getBoundingClientRect().x - previousClosestEl.getBoundingClientRect().x)) {
        previousClosest = i;
      } else {
        break;
      }
    }

    onClosestChildChange(previousClosest);
  }, 500), [carouselContainerRef, childrenRefs, onClosestChildChange]);
  const childrenWithRefs = useMemo(() => {
    const refs = [];
    const returnableChildren = children.map((child, index) => {
      return /*#__PURE__*/_jsx("div", {
        className: "carousel-child",
        ref: ref => refs[index] = ref,
        children: child
      }, index);
    });
    setChildrenRefs(refs);
    return returnableChildren;
  }, [children]);
  const containerRef = useRef();
  const defaultMargin = isMobile ? 12 : 48;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(CarouselOuter, {
      fixedMargin: fixedMargin ? 1 : 0,
      pageMargin: pageMargin || defaultMargin,
      ref: containerRef,
      children: /*#__PURE__*/_jsx(CarouselFlex, {
        className: carouselClassName,
        onScroll: handleCarouselScroll,
        ref: ref => setCarouselContainerRef(ref),
        children: childrenWithRefs
      })
    }), /*#__PURE__*/_jsx(Scrollbar, {
      scrollableContentRef: containerRef
    })]
  });
};

export default Carousel;